module.exports = __webpack_public_path__ + "static/media/user-circle.f7bdc5a4.svg";